import { combineReducers } from "redux";
import { organizationSlice } from "./organizationReducer";
import { maintenanceReducer } from "./maintenanceReducer";
import { workInstructionSlice } from "./workReducer";
import { serviceSlice } from "./serviceReducer";
import { scopingHeaderSlice } from "./scopingHeaderReducer";
import { procedureSlice } from "./procedureReducer";
import { workItemsSlice } from "./workItemsReducer";
import { workEventSlice } from "./workEventReducer";

const rootReducer = combineReducers({
  organization: organizationSlice.reducer,
  maintenancePlan: maintenanceReducer,
  workInstruction: workInstructionSlice.reducer,
  procedure: procedureSlice.reducer,
  workItems: workItemsSlice.reducer,
  service: serviceSlice.reducer,
  workEvent: workEventSlice.reducer,
  scopingHeader: scopingHeaderSlice.reducer,
});
export default rootReducer;
